module.exports = __webpack_public_path__ + "img/john-tyler.4aa66cc9.png";